import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
// Iter-278.K — Sentry observability. No-op when REACT_APP_SENTRY_DSN
// is unset, so this import is always safe.
import { initSentry } from "@/lib/sentry";
import { installSeoHeadDedupe } from "@/lib/seoHeadDedupe";

initSentry();
installSeoHeadDedupe();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
